<template>
  <div class="view">
    <Title title="イベント"/>
    <EventEditMain />
  </div>
</template>

<script>
import Title from '@/components/Title.vue'
import EventEditMain from '@/components/Event/EditMain'

export default {
  components: {
    Title,
    EventEditMain
  }
}
</script>
